import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story08.content'
import type { Article } from './types'

const t = translations
// The directory holds nine frames; this piece uses 01–04 and the rest are spares.
const dir = '/mine-my-phone/images/articles/story08'
const figure = articleFigure(dir)

export const story08: Article = {
  id: 8,
  slug: 'interview-siddharth-kara-cobalt-red-author',
  order: 8,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('cobalt'),
  author: 'Thomas Hobbs',
  // Country-level tag, so the pin goes to Kolwezi — offset from the cobalt sheet's
  // Mutanda & Kamoto marker, since stacked markers hide each other.
  region: [
    {
      name: 'Kolwezi',
      country: 'DR Congo',
      coordinates: [25.47, -10.72],
      impact: 'human',
    },
  ],
  impactList: ['human', 'environmental'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[1]] },
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[2]] },
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[3]] },
      figure('04.jpg', t.captions[3]),
      { type: 'prose', blocks: [...t.prose[4]] },
    ],
  },
}
